module.exports = "<div class=\"row bg-light lter b-b wrapper-md\">\n  <div class=\"container\">\n    <h1 class=\"m-n font-thin h3 welcome\" id=\"details-submitted\" style=\"color: green;\">\n      Your details have been submitted successfully</h1>\n      <br>\n      <br>\n        <a style=\"text-align: center\" class=\"btn btn-primary\" [routerLink]=\"'/lots/'+lotId\">New Verification</a>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/ocr/ocr-sucess-page/ocr-sucess-page.component.html
// module id = ../../../../../src/app/ocr/ocr-sucess-page/ocr-sucess-page.component.html
// module chunks = 0